var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MoopsyError } from "@moopsyjs/core";
import { TimeoutError } from "./errors/timeout-error";
import { isMoopsyError } from "../lib/is-moopsy-error";
import { MutationCall } from "./mutation-call";
import { TypedEventEmitterV3 } from "@moopsyjs/toolkit";
import { ReadableMoopsyStream } from "./readable-moopsy-stream";
import { InvariantError } from "./error";
export class MutationError extends MoopsyError {
    constructor(code, error, description, source) {
        super(code, error, description);
        this.source = source;
    }
}
export class MoopsyMutation {
    constructor(client, plug, options, isQuery) {
        this.isQuery = isQuery;
        this.loading = false;
        this.error = null;
        this.activeCalls = [];
        this.timeout = 10000;
        this.changeEmitter = new TypedEventEmitterV3();
        this._fireChanged = () => {
            this.changeEmitter.emit("changed", null);
        };
        this.call = (params) => __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            this.error = null;
            const mutationCall = new MutationCall(this);
            const mutationId = mutationCall.callId;
            this.activeCalls = [...this.activeCalls, { mutationId, startDate: new Date(), params }];
            this._fireChanged();
            yield mutationCall.callMutation(params);
            const response = yield mutationCall.awaitResult();
            this.loading = false;
            const activeIndex = this.activeCalls.findIndex((call) => call.mutationId === mutationId);
            if (activeIndex !== -1) {
                this.activeCalls.splice(activeIndex, 1);
            }
            if (isMoopsyError(response)) {
                this.error = response instanceof TimeoutError ? response : new MutationError(response.code, response.error, response.description, this.plug.Endpoint);
                this._fireChanged();
                throw this.error;
            }
            const mutationResult = response.mutationResult;
            if (response == null) {
                throw new InvariantError("Mutation response is null");
            }
            if (!Array.isArray(response.sideEffectResults)) {
                throw new InvariantError("Mutation response sideEffectResults is not an array");
            }
            for (const sideEffectResult of response.sideEffectResults) {
                if (typeof sideEffectResult.sideEffectId === "number") {
                    const query = this.querySideEffects[sideEffectResult.sideEffectId];
                    if (query) {
                        query._.onSideEffectResult(sideEffectResult.result);
                    }
                }
            }
            if (typeof mutationResult === "object" && mutationResult != null && mutationResult instanceof Object) {
                for (const [key, value] of Object.entries(mutationResult)) {
                    if (typeof value === "object" && value instanceof Object && "__moopsyStream" in value) {
                        mutationResult[key] = new ReadableMoopsyStream(value, mutationCall, this.client);
                    }
                }
            }
            this._fireChanged();
            return mutationResult;
        });
        this.client = client;
        this.plug = plug;
        this.querySideEffects = options.querySideEffects;
        if (options.timeout) {
            this.timeout = options.timeout;
        }
    }
}
